/**
 * Curseur animé du tutoriel : un pointeur qui suit la poignée du faux widget
 * pendant la démonstration de redimensionnement (animation pilotée en CSS).
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function TutorialCursor({ running }: { running: boolean }) {
  return (
    <div
      className={`tutorial-cursor ${running ? "is-running" : ""}`}
      aria-hidden="true"
    >
      <span className="tutorial-cursor-ring" />
      <FontAwesomeIcon
        icon="arrow-pointer"
        className="tutorial-cursor-icon text-default-text"
      />
    </div>
  );
}
